import { FC } from 'react'

import cn from 'clsx'

import { ORDER_ACTION_TYPE } from '@UI/crypto_exchange/desktop/pages/spot/components/SpotOrderTrade/components/types'

import s from './styles.module.scss'

export const AlertTypeMarker: FC<{ type: string; className?: string }> = ({ type, className }) => {
  return <span className={cn(className, s.type, type === ORDER_ACTION_TYPE.BUY && s.typeBuy)}>{type}</span>
}
